// src/components/ui/atoms/DayCardAddToMealButton.tsx
import React from 'react';
import { AiOutlinePlus } from 'react-icons/ai';

interface DayCardAddToMealButtonProps {
  onAdd: () => void;
}

const DayCardAddToMealButton: React.FC<DayCardAddToMealButtonProps> = ({
  onAdd,
}) => (
  <button
    onClick={onAdd}
    className="
      inline-flex items-center
      px-3 py-1
      text-sm font-medium
      bg-black text-white
      border border-black
      rounded-full
      hover:bg-gray-800
      transition
    "
    type="button"
  >
    <AiOutlinePlus className="w-4 h-4 mr-1 text-white" />
    Add
  </button>
);

export default DayCardAddToMealButton;
